module.exports = __webpack_public_path__ + "8c7fa77832aa518d5d973a7bc853de13.MP3";